import Styles from './InviteOperatorUserModal.module.css'
import Colors from 'Theme/Colors'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { CheckPicker } from 'rsuite'
import InfinityEnums from 'Enums/InfinityEnums'
import FormControl from '@mui/material/FormControl'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import { IFModal, IFButton, IFTextInput, IFText } from 'Components'
import React, { useState, useEffect } from 'react'
import validator from 'validator'
import RequestState from 'Enums/RequestState'
import PropTypes from 'prop-types'

const transformPermissions = (permissions) => {
  const transformedPermissions = permissions.map((permission) => {
    let lowerCase = permission.toLowerCase()
    lowerCase = lowerCase.replace(/_/g, ' ')
    return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1)
  })
  return transformedPermissions
}

const convertPermissionsBack = (permissions) => {
  let upperCasePermissions = permissions.map((permission) => {
    let temp = permission.toUpperCase()
    return temp.replace(/ /g, '_')
  })
  let OperatorUserEnums = Object.keys(InfinityEnums.OperatorUserPermission)
  upperCasePermissions = upperCasePermissions.map((permission) => {
    const index = OperatorUserEnums.findIndex(
      (operatorUserEnum) => operatorUserEnum === permission,
    )
    if (index != -1) return index + 1
  })

  return upperCasePermissions
}

const InviteOperatorUserModal = React.forwardRef(
  ({ inviteOperatorUser, inviteOperatorUserRequestState }, ref) => {
    const [email, setEmail] = useState('')
    const [selectedPermissions, setSelectedPermissions] = useState([])
    const [emailError, setEmailError] = useState('')
    const [permissionsError, setPermissionsError] = useState('')
    const [canSubmit, setCanSubmit] = useState(false)

    useEffect(() => {
      if (inviteOperatorUserRequestState === RequestState.SUCCEEDED) {
        ref.current.dismiss()
      }
    }, [inviteOperatorUserRequestState])

    const { t } = useTranslation()
    const permissions = transformPermissions(
      Object.keys(InfinityEnums.OperatorUserPermission),
    )

    const options = []
    for (const index in permissions) {
      options.push({
        label: permissions[index],
        value: permissions[index],
      })
    }

    const handleModalClose = () => {
      setEmailError('')
      setPermissionsError('')
      setCanSubmit(false)
      setSelectedPermissions([])
      setEmail('')
    }

    const handleSubmit = () => {
      const transformedPermissions = convertPermissionsBack(selectedPermissions)
      const data = {
        email: email,
        permissions: transformedPermissions,
      }
      inviteOperatorUser(data)
    }
    return (
      <IFModal
        onDismiss={handleModalClose}
        title={t('OperatorUserPageContainer.InviteOperatorUser')}
        ref={ref}
      >
        <div className={Styles.Outer}>
          <div className={Styles.inputContainer}>
            <IFText className={Styles.label}>
              {t('OperatorUserPageContainer.Email')}
            </IFText>
            <IFTextInput
              placeholder={t(
                'OperatorUserPageContainer.EmailAddressPlaceholder',
              )}
              style={{ caretColor: Colors.primary }}
              className={Styles.input}
              isFixed={true}
              value={email}
              name="email"
              type="email"
              onChange={(e) => {
                setEmail(e.target.value)
                e.target.value.length === 0
                  ? setEmailError(t('OperatorUserPageContainer.Required'))
                  : validator.isEmail(e.target.value)
                  ? setEmailError('')
                  : setEmailError(t('OperatorUserPageContainer.EmailError'))
                const submit =
                  validator.isEmail(e.target.value) &&
                  selectedPermissions.length > 0
                setCanSubmit(submit)
              }}
              onBlur={(e) => {
                e.target.value.length === 0
                  ? setEmailError(t('OperatorUserPageContainer.Required'))
                  : validator.isEmail(e.target.value)
                  ? setEmailError('')
                  : setEmailError(t('OperatorUserPageContainer.EmailError'))
                const submit =
                  validator.isEmail(e.target.value) &&
                  selectedPermissions.length > 0
                setCanSubmit(submit)
              }}
              {...(emailError.length > 0 ? { errorText: emailError } : {})}
            />
          </div>
          <div className={Styles.CheckPickerContainer}>
            <IFText className={Styles.label}>
              {t('OperatorUserPageContainer.Permissions')}
            </IFText>
            <FormControl
              sx={{
                width: '18rem',
                boxShadow: `0px 0px 4px ${Colors.black}`,
                borderRadius: '5px',
              }}
              className={Styles.FormControl}
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <CheckPicker
                size="lg"
                value={selectedPermissions}
                placeholder={
                  <IFText className={Styles.CheckPickerPlaceholder}>
                    {t('OperatorUserPageContainer.Select')}
                  </IFText>
                }
                renderValue={(value) => {
                  const pickedPermissions = value
                  const first = pickedPermissions[0]
                  const count = pickedPermissions.length

                  return (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: '100%',
                        paddingRight: '2rem',
                      }}
                    >
                      <IFText
                        style={{
                          flex: 1,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          marginRight: '0.5rem',
                        }}
                      >
                        {first ||
                          t('OperatorUserListItem.NoPermissionsSelected')}
                      </IFText>

                      {count > 1 && (
                        <IFText style={{ flexShrink: 0 }}>{`+${
                          count - 1
                        }`}</IFText>
                      )}
                    </div>
                  )
                }}
                searchable={false}
                preventOverflow={true}
                data={options}
                menuStyle={{
                  color: Colors.text,
                  zIndex: 1500,
                }}
                onChange={(e) => {
                  setSelectedPermissions(e)
                  e.length === 0
                    ? setPermissionsError(
                        t('OperatorUserPageContainer.Required'),
                      )
                    : setPermissionsError('')
                  const submit = validator.isEmail(email) && e.length > 0
                  setCanSubmit(submit)
                }}
                onOpen={() => {
                  selectedPermissions.length === 0
                    ? setPermissionsError(
                        t('OperatorUserPageContainer.Required'),
                      )
                    : setPermissionsError('')
                }}
              />
            </FormControl>
            <div style={{ color: Colors.red }} className={Styles.ErrorStyling}>
              {permissionsError.length > 0 ? (
                <IFText>{permissionsError}</IFText>
              ) : null}
            </div>
          </div>
          <div className={Styles.Submit}>
            <IFButton
              text={t('OperatorUserPageContainer.Submit')}
              color={Colors.primary}
              isFill={true}
              isLoading={
                inviteOperatorUserRequestState === RequestState.LOADING
              }
              size="sm"
              onClick={handleSubmit}
              isDead={!canSubmit}
            ></IFButton>
          </div>
        </div>
      </IFModal>
    )
  },
)

function mapDispatchToProps(dispatch) {
  return {
    inviteOperatorUser: (operatorUserData) =>
      dispatch(OperatorUserActions.inviteOperatorUser(operatorUserData)),
  }
}

const mapStateToProps = (state) => ({
  inviteOperatorUserRequestState:
    OperatorUserSelectors.getInviteOperatorUserRequestState(state),
})

InviteOperatorUserModal.propTypes = {
  inviteOperatorUser: PropTypes.func,
  inviteOperatorUserRequestState: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(InviteOperatorUserModal)
